import styled from "styled-components";
import theme from "../theme";

interface Props {
  centered?: boolean;
}

const Box = styled.div<Props>`
  padding: ${theme.unit}px ${theme.unit * 0.5}px;
  margin-bottom: ${theme.unit * 2}px;
  text-align: ${(props) => (props.centered ? "center" : "left")};

  @media (min-width: ${theme.mediaQueries.tablet}px) {
  }
`;

export default Box;
